import { CSSProperties, FC } from 'react';
import { AvatarGroup, useTheme } from '@mui/material';
import { Avatar } from '../../components/Avatar';
import { Theme } from '@mui/material';
import { FragmentType, getFragmentData, graphql } from '../../gql';

const memberFragment = graphql(`
	fragment CustomAvatarGroup_Member on Member {
		id
		name
		avatar {
			url24: url(width: 24, height: 24)
		}
	}
`);

type MemberFragment = FragmentType<typeof memberFragment>;

export const AvatarGroupItemStyles = (theme: Theme): CSSProperties => ({
	width: '24px',
	height: '24px',
	fontSize: '12px',
	color: theme.palette.grey[600],
	border: 'none',
});

export const CustomAvatarGroup: FC<{ readonly avatarList: readonly MemberFragment[]; readonly max: number }> = ({ avatarList, max }) => {
	const theme = useTheme();

	const avatarListData = avatarList.map((avatar) => getFragmentData(memberFragment, avatar));

	return (
		<AvatarGroup max={max} sx={{ '.MuiAvatarGroup-avatar': AvatarGroupItemStyles(theme), alignItems: 'center' }}>
			{avatarListData.slice(0, max - 1).map((avatar, i) => (
				<Avatar key={i} sx={{ width: 24, height: 24 }} alt={'avatar-alt-text'} src={avatar.avatar?.url24 ?? undefined} />
			))}
			{avatarListData.length > max - 1 && (
				// eslint-disable-next-line formatjs/no-literal-string-in-jsx
				<Avatar sx={{ paddingLeft: '5px', borderColor: 'transparent !important', background: 'none' }}>
					+{avatarList.length - max + 1}
				</Avatar>
			)}
		</AvatarGroup>
	);
};
